import { render } from "./recordDetail.vue?vue&type=template&id=56e51493&scoped=true"
import script from "./recordDetail.vue?vue&type=script&lang=js"
export * from "./recordDetail.vue?vue&type=script&lang=js"

import "./recordDetail.vue?vue&type=style&index=0&id=56e51493&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e51493"],['__file',"src/views/alfmeier/rank/recordDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56e51493"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56e51493', __exports__)) {
    console.log('reload')
    api.reload('56e51493', __exports__)
  }
  
  module.hot.accept("./recordDetail.vue?vue&type=template&id=56e51493&scoped=true", () => {
    console.log('re-render')
    api.rerender('56e51493', render)
  })

}


export default __exports__